function FiltroDespesasUsuario() {
  const $inputModeloRelatorio = $('#tipoRelatorio');
  $inputModeloRelatorio.on('change', handlerChangeModeloRelatorio);
}

function handlerChangeModeloRelatorio(event) {
  let $inputStatus = $('#status')[0];
  const $inputModeloRelatorio = $(event.target)[0].selectize;
  const status = JSON.parse($inputStatus.dataset.filterStatus);

  $inputStatus = $inputStatus.selectize;
  $inputStatus.clearOptions();
  addOptions($inputStatus, status[$inputModeloRelatorio.getValue()]);
}

function addOptions(selectize, options) {
  Object.keys(options).forEach( currentKey => {
    selectize.addOption({
      value: currentKey,
      text: options[currentKey]
    });
  })
}

module.exports = {
  init: FiltroDespesasUsuario,
  url: route('app.admin.relatorio-usuarios')
}

